document.addEventListener('click', (event) => {
  const link = event.target.closest('.pw-mobile a');
  if (link) {
    const menu = link.closest('.pw-mobile');
    menu.querySelectorAll('details[open]').forEach((submenu) => { submenu.open = false; });
    menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const focusedDisclosure = document.activeElement?.closest('.pw-submenu[open]');
  const menu = focusedDisclosure || document.querySelector('.pw-mobile[open]');
  if (menu) {
    menu.querySelectorAll('details[open]').forEach((submenu) => { submenu.open = false; });
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});
